import { useCallback, useEffect } from "react";
import { useState } from "react";
import postItemService from "../../../Axios/services/postItem.service";
import { toJsonShape, isMobileApp } from "../../../helpers/helpers";
import { HartmanLinkProps } from "./HartmanLinkProps"

export const HartmanLinkComp = (props: HartmanLinkProps) => {

    const [img, setImg] = useState();
    const [jsonContent] = useState(toJsonShape(props.json));
    const isMobile = isMobileApp();

    const renderTitle = () => {
        let r;
        if (jsonContent.title && jsonContent.link) {
            r = <div className={"row my-4 h4 justify-content-center align-items-center"} >
                <a rel="noreferrer" href={jsonContent.link} target={isMobile ? "_self" : "_blank"}>
                    <div className="col-12" dangerouslySetInnerHTML={{ __html: jsonContent.title.rendered }}>
                    </div>
                </a>
            </div>
        }
        return r;
    }

    const renderContent = () => {
        let r;
        if (jsonContent.content) {
            r = <div className={"my-3"} dangerouslySetInnerHTML={{ __html: jsonContent.content.rendered }}></div>
        }
        return r;
    }

    const renderExcerpt = () => {
        let r;
        if (jsonContent.excerpt) {
            r = <div dangerouslySetInnerHTML={{ __html: jsonContent.excerpt.rendered }}></div>
        }
        return r;
    }

    const renderDate = () => {
        let r;
        if (jsonContent.date) {
            r = <div dangerouslySetInnerHTML={{ __html: jsonContent.date.rendered }}></div>
        }
        return r;
    }



    const retrieveImage = useCallback(async () => {
        try {
            if (jsonContent.featured_media && jsonContent.featured_media !== 0) {
                const image_url = await postItemService.getMediaWP(jsonContent.featured_media);
                setImg(image_url);
            }

        } catch (err) {
            console.error(err);
        }
    }, [jsonContent.featured_media])

    useEffect(() => {
        retrieveImage()
    }, [retrieveImage])

    return <div className="container">
        <div className="row m-0 p-0">
            {renderTitle()}
            {renderExcerpt()}
            {renderDate()}
            {renderContent()}
            {img ? <img src={img} alt={'wp-media'} /> : null}
        </div>
    </div>

}